import React, { useEffect, useRef } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import DropdownButton from "react-bootstrap/DropdownButton";
import "./FormDropdown.css";
import { motion, AnimatePresence } from "framer-motion";

interface FormDropdownProps {
  isVisible: boolean;
  setIsVisible: (value: boolean) => void;
  value: number;
  setValue: (value: number) => void;

  error: string;
  title: string;
}

const FormDropdown: React.FC<FormDropdownProps> = ({
  isVisible,
  setIsVisible,
  value,
  setValue,
  title,
  error,
}) => {
  const gradeDropdownRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        gradeDropdownRef.current &&
        !gradeDropdownRef.current.contains(event.target as Node)
      ) {
        console.log("Clicked outside the component");
        setIsVisible(false);
      }
    };

    document.addEventListener("click", handleClickOutside);

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  console.log({ isVisible });
  return (
    <div id="gradeDropdown" ref={gradeDropdownRef} className="dropdown-parent">
      <div className="form-dropdown-title">{title}</div>
      <Dropdown
        show={isVisible}
        onClick={() => {
          setIsVisible(!isVisible);
        }}
      >
        <Dropdown.Toggle className="dropdown-input">
          {value === 0 ? "Select Grade" : `Grade ${value}`}
        </Dropdown.Toggle>

        <AnimatePresence>
          {isVisible && (
            <motion.div
              initial={{ scale: 0.7, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.7, opacity: 0 }}
              transition={{
                scale: { type: "spring", stiffness: 400, damping: 22 },
                opacity: { duration: 0.15, ease: "easeOut" },
                exit: {
                  scale: { type: "spring", stiffness: 400, damping: 22 },
                  opacity: { duration: 0.1, ease: "easeOut" },
                },
              }}
              style={{
                transformOrigin: "top",
                display: "flex",
                flexDirection: "column",
                zIndex: 999,
                backgroundColor: "white",
                alignItems: "center",
                justifyContent: "center",
                // padding: "8px 10px",
                borderRadius: "14px",
                width: "100%",
                border: "0.5px solid rgba(0, 0, 0, 0.1)",
                margin: "2px 0px",
                position: "absolute",
                boxShadow: "0px 0px 10px 0px rgba(0, 0, 0, 0.1)",
                overflow: "hidden",
              }}
            >
              <Dropdown.Item
                onClick={() => {
                  setValue(5);
                  sessionStorage.setItem("grade", "5");
                }}
                className={`dropdown-item${value === 5 ? " selected" : ""}`}
              >
                Grade 5
              </Dropdown.Item>
              <Dropdown.Item
                onClick={() => {
                  setValue(6);
                  sessionStorage.setItem("grade", "6");
                }}
                className={`dropdown-item${value === 6 ? " selected" : ""}`}
              >
                Grade 6
              </Dropdown.Item>
              <Dropdown.Item
                onClick={() => {
                  setValue(7);
                  sessionStorage.setItem("grade", "7");
                }}
                className={`dropdown-item${value === 7 ? " selected" : ""}`}
              >
                Grade 7
              </Dropdown.Item>
              <Dropdown.Item
                onClick={() => {
                  setValue(8);
                  sessionStorage.setItem("grade", "8");
                }}
                className={`dropdown-item${value === 8 ? " selected" : ""}`}
              >
                Grade 8
              </Dropdown.Item>
              <Dropdown.Item
                onClick={() => {
                  setValue(9);
                  sessionStorage.setItem("grade", "9");
                }}
                className={`dropdown-item${value === 9 ? " selected" : ""}`}
              >
                Grade 9
              </Dropdown.Item>
              <Dropdown.Item
                onClick={() => {
                  setValue(10);
                  sessionStorage.setItem("grade", "10");
                }}
                className={`dropdown-item${value === 10 ? " selected" : ""}`}
              >
                Grade 10
              </Dropdown.Item>
              <Dropdown.Item
                onClick={() => {
                  setValue(11);
                }}
                className={`dropdown-item${value === 11 ? " selected" : ""}`}
              >
                Grade 11
              </Dropdown.Item>
              <Dropdown.Item
                onClick={() => {
                  setValue(12);
                }}
                className={`dropdown-item${value === 12 ? " selected" : ""}`}
              >
                Grade 12
              </Dropdown.Item>
            </motion.div>
          )}
        </AnimatePresence>
        {error && <div className="error-message">{error}</div>}
      </Dropdown>
    </div>
  );
};

export default FormDropdown;
